import axios from "axios";
import {
    SET_KPI_STATUS_REQUEST,
    SET_KPI_STATUS_SUCCESS,
    SET_KPI_STATUS_ERROR,
} from "./../../constants/kpiSummaryDashboardEnhancement/ExpandableKpiSummaryComponentConstants";

export const fetchKpiStatusForAScenario = (payload) => (dispatch) => {
    try {
        dispatch({ type: SET_KPI_STATUS_REQUEST });
        return axios({
            url: `/get/individual/scenario/all/kpi_status?scenario_uuid=${payload}`,
            method: "GET",
        })
            .then((response) => {
                if (response && response.status === 200) {
                    dispatch({
                        type: SET_KPI_STATUS_SUCCESS,
                        successSummaryScenarioKpiStatus: response.data.result,
                    });
                    return response.data.result;
                } else {
                    dispatch({
                        type: SET_KPI_STATUS_ERROR,
                        payload: "Error occurred while fetching this request",
                    });
                }
            })
            .catch((error) => {
                dispatch({
                    type: SET_KPI_STATUS_ERROR,
                    payload: error.response.data.message,
                });
            });
    } catch (error) {
        console.log("error msg", error);
        const errorMsg =
            error.message || "Error occurred while fetching this request!";
        dispatch({ type: SET_KPI_STATUS_ERROR, payload: errorMsg });
    }
};
